import React, { useContext } from 'react'
import { useEffect, useState } from 'react';
import { deleteChat, onlineStatus } from '../../api/chat';
import { DarkModeContext } from '../../global/Theme'
import './index.sass'
import { useDispatch, useSelector } from 'react-redux';
import { toggleNotification } from '../../api/chat';
import { isStarred, starUser, unStarUser } from '../../api/social';
import moment from 'moment';
import { useHistory, useLocation } from 'react-router';



export default function ChatHeader({ data, onRefresh }) {
    const [width, setWidth] = useState(document.body.clientWidth);
    const [isMobile, setIsMobile] = useState(false);
    const { isDark } = useContext(DarkModeContext);
    const loggedInUser = useSelector(state => state.userState.id);
    const [starred, setStarred] = useState(null);
    const [status, setStatus] = useState({ state: '', last_changed: '' })
    const [notification, setNotification] = useState(null);
    const [isDeletePromptVisible, setIsDeletePromptVisible] = useState(false)
    const [timeAgo, setTimeAgo] = useState('');
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();

    const updateWidth = () => {
        setWidth(document.body.clientWidth)
    }

    useEffect(() => {
        window.addEventListener('resize', updateWidth);

        if(width < 750){
            setIsMobile(true)
        } else {
            setIsMobile(false)
        }

        return () => {window.removeEventListener('resize', updateWidth)}
    }, [width])

    const getTimeAgo = (time) => {
        try {
            setTimeAgo(moment(time).fromNow())
        } catch (e) { }
    }




    const removeUser = async (e) => {

        e.stopPropagation();
        await deleteChat(data.id)
        dispatch({
            type: 'SET_NOTIFICATION', payload: {
                isEnabled: true,
                text: `Deleted ${data.user.username}`,
                icon: 'notifcomment.svg'
            }
        })
        await sleep(3000)
        dispatch({
            type: 'SET_NOTIFICATION', payload: {
                isEnabled: false,
                text: '',
                icon: ''
            }
        })
        if(location.state){
            location.state = null;
        }
        window.location.reload()


    }

    const handleDeletePostPrompt = async (e) => {
        e.stopPropagation();

        if (!isDeletePromptVisible)
            setIsDeletePromptVisible(true)
        else {
            document.getElementById('deletePrompt').style.transform = 'scale(0)'
            setIsDeletePromptVisible(false)
        }
    }

    const handleDeleteDialogTransition = async () => {
        if (isDeletePromptVisible) {
            document.getElementById('deletePrompt').style.transform = 'scale(1)'
            await sleep(1000)
        }
    }

    useEffect(() => {
        handleDeleteDialogTransition()
    }, [isDeletePromptVisible])



    useEffect(() => {
        if (data) {
            setNotification(data.notification[`${loggedInUser}`])
            checkStarred()
        }
    }, [data])




    const checkStarred = async () => {
        const res = await isStarred(data.user)
        setStarred(res);
    }

    const sleep = async (ms) => {
		return new Promise(resolve => setTimeout(resolve, ms))
	}

    const toggleStar = async () => {
        if(starred){
            await unStarUser(data.user.id);
            checkStarred()
            dispatch({
                type: 'SET_NOTIFICATION', payload: {
                    isEnabled: true,
                    text: `Unstarred ${data.user.username}`,
                    icon: 'notifcomment.svg'
                }
            })
            await sleep(3000)
            dispatch({
                type: 'SET_NOTIFICATION', payload: {
                    isEnabled: false,
                    text: '',
                    icon: ''
                }
            })
        }
        else{
            await starUser(data.user.id);
            checkStarred()
            dispatch({
                type: 'SET_NOTIFICATION', payload: {
                    isEnabled: true,
                    text: `Starred ${data.user.username}`,
                    icon: 'notifcomment.svg'
                }
            })
            await sleep(3000)
            dispatch({
                type: 'SET_NOTIFICATION', payload: {
                    isEnabled: false,
                    text: '',
                    icon: ''
                }
            })
        }
    }

    const handleToggleNotifications = async (e) => {
        e.stopPropagation()
        e.preventDefault()
        if (notification) {
            await toggleNotification(loggedInUser, data.id, false)
            setNotification(false);
            dispatch({
                type: 'SET_NOTIFICATION', payload: {
                    isEnabled: true,
                    text: 'Notification Disabled',
                    icon: 'notifcomment.svg'
                }
            })
            await sleep(3000)
            dispatch({
                type: 'SET_NOTIFICATION', payload: {
                    isEnabled: false,
                    text: '',
                    icon: ''
                }
            })
        }
        else {
            await toggleNotification(loggedInUser, data.id, true)
            setNotification(true);
            dispatch({
                type: 'SET_NOTIFICATION', payload: {
                    isEnabled: true,
                    text: 'Notification Enabled',
                    icon: 'notifcomment.svg'
                }
            })
            await sleep(3000)
            dispatch({
                type: 'SET_NOTIFICATION', payload: {
                    isEnabled: false,
                    text: '',
                    icon: ''
                }
            })
        }
    }

    const goBackToChatList = () => {
        if (document.body.clientWidth < 750) {
            document.getElementById('chatLeftCol').style.display = "flex";
            document.getElementById('chatRightCol').style.display = "none";
            document.getElementById('desktopWrapper').style.display = "flex";
            document.getElementById('mobileWrapper').style.display = "flex";
            document.getElementById('mainWrapper').style.cssText = "padding: 85px 0 0 0 !important"
            if(document.body.clientWidth < 580){
                document.getElementById('mainWrapper').style.cssText = "padding: 70px 10px !important"
            }
        }
    }

    const getOnlineStatus = async () => {
        onlineStatus(data.user.id, observer => {
            if (observer.val()) {
                setStatus(observer.val())
            } else {
                setStatus({ state: 'offline', last_changed: '' })
            }
        })
    }

    useEffect(() => {
        if (data) {
            getOnlineStatus()
        }
    }, [data])

    useEffect(()=>{
        getTimeAgo(status.last_changed)
        setInterval(()=>{
            getTimeAgo(status.last_changed)

        }, 1000*60)
    }, [status])

    const handleOpenProfile = () => {
        history.push(`/user/${data.user.username}`)
    }

    return (
        data != null && data != undefined && data ? <div id="chatHeaderWrapper" className={`${isDark ? 'chat-header-dark' : 'chat-header-light'}`}>
            <div id="chatUserInfo">
                {isMobile ? <img onClick={goBackToChatList} id="backToChatListButton" alt="goback" src={require('../../assets/icons/backbutton.svg')} /> : ''}
                <img src={data.user.image} style={{cursor: 'pointer'}} onClick={handleOpenProfile} alt="user" />
                <div onClick={handleOpenProfile} style={{cursor: 'pointer'}} >
                    <h3>{data.user.name}</h3>
                    <div id="chatUserStatus">
                        {status.state == 'online' ? <div className="user-online"></div> : <div className="user-offline"></div>}
                        <p>{status.state == 'online' ? 'Online Now' :  timeAgo != 'Invalid Date' && timeAgo}</p>
                    </div>
                </div>
            </div>
            <div id="chatUserActions">
                <div id='favs'>
                   {starred != null && <img onClick={toggleStar} src={starred ? require('../../assets/icons/star_a.svg') : require('../../assets/icons/star.svg')} alt='favs' /> }
                </div>
                <div id='mute-notif'>
                    {data.notification[`${loggedInUser}`] != null && <img onClick={handleToggleNotifications} className="mute-notif" src={!notification ? require('../../assets/icons/notification_mute.svg') : require('../../assets/icons/notifications.svg')} />}
                </div>
                <div id='delete'>
                    <img onClick={handleDeletePostPrompt} src={require('../../assets/icons/trash_a.svg')} alt='delete' />
                    {isDeletePromptVisible && <div id="deletePrompt">
                        <div id="deletePromptWrapper">
                            <img src={require("../../assets/icons/polygon.svg")} />
                            <div id="deleteDialog">
                                <h1>Are you sure?</h1>
                                <div id="deleteDialogActions">
                                    <div id="circleCross">
                                        <img onClick={handleDeletePostPrompt} src={require("../../assets/icons/cross.svg")} />
                                    </div>
                                    <div onClick={removeUser} id="postDeleteButton">
                                        <p>Delete</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div> : <div id="chatHeaderWrapper"></div>
    )
}
